import { WidgetStreamStreamingConfig } from 'widgets/streaming/WidgetStreamConfig';
import { selectStreamKey } from 'widgets/openSubmissions/capsule/store/selectors';
import { OpenSubmissionsElement } from 'communication/types/openSubmissions/OpenSubmissionsElement';
import { createOrderIdsStreamRequest } from 'widgets/streaming/OrderIdsStreamRequest';
import { OrderIdsStreamRequest } from 'communication/types/order/OrderIdsStreamRequest';
import { clearOpenSubmissionsCapsuleStreamData } from 'widgets/openSubmissions/capsule/store/actions';

export const openSubmissionsCapsuleWidgetStreamConfig: WidgetStreamStreamingConfig<
    OrderIdsStreamRequest,
    OpenSubmissionsElement
> = {
    configType: 'OrderIdsDependentWidgetStreamConfig',
    streamType: 'StreamingStream',
    startChannelDestination: 'startOpenSubmissionsByOrderIdsStream',
    createPayload: createOrderIdsStreamRequest,
    selectWidgetStreamKey: selectStreamKey,
    clearWidgetStreamData: clearOpenSubmissionsCapsuleStreamData,
};
